const range = document.getElementById('range');
const bubble = document.getElementById('bubble');
const rangeLine = document.getElementById('range-line');
const selectedSoftwarePrice = document.getElementById('selected-software-price');
const softwareBoxItems = document.querySelectorAll('.software-box-item');
const repalaceAppCount = document.getElementById('replace-app-count');
const replaceAppCountSmall = document.getElementById('replace-app-count--small');
const compareSoftwareBoxes = document.querySelectorAll('.compare-software-item-box');
const selectedBundlePrice = document.getElementById('bundle-price');
const numOfPeople = document.getElementById('num-of-people');
const saveAmountElement = document.getElementById('save-amount');
const saveAmountSmallElement = document.getElementById('save-amount--small');
const selectAppWarning = document.getElementById('select-app-warning');
const totalUsers = document.querySelectorAll('.total-users');

const cakeBundlePrice = 12.99;
const steps = {
  1: 1, 2: 10, 3: 20, 4: 30, 5: 40, 6: 50, 7: 60, 8: 70, 9: 80, 10: 90,
  11: 100, 12: 140, 13: 180, 14: 220, 15: 260, 16: 300, 17: 340, 18: 380, 19: 420, 20: 460,
  21: 500, 22: 550, 23: 600, 24: 650, 25: 700, 26: 750, 27: 800, 28: 850, 29: 900, 30: 950, 31: 1000
};

const formatPriceUsStandard = (price) => {
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(price);
};

const updatePriceElement = (element, price, includeDollarSign = false) => {
  const formattedPrice = formatPriceUsStandard(price);
  const [dollars, cents] = formattedPrice.split('.');
  const dollarPrefix = includeDollarSign ? '$' : '';
  element.innerHTML = `${dollarPrefix}${dollars}<span class="small-decimals">.${cents}</span>`;
};

const getCheckedAppsData = () => {
  let count = 0;
  let totalPrice = 0;

  softwareBoxItems.forEach(element => {
    if (element.classList.contains('active')) {
      const priceText = element.querySelector('.software-box-item__price').textContent;
      const price = parseFloat(priceText);
      count++;
      totalPrice += price;
    }
  });

  return { count, totalPrice: Math.round(totalPrice * 100) / 100 };
};

const setValue = () => {
  const min = parseInt(range.min);
  const max = parseInt(range.max);
  const val = parseInt(range.value);
  const controlThumbWidth = parseFloat(range.dataset.thumbwidth);

  const computedStepValue = steps[val];
  const position = ((val - min) / (max - min)) * 100;
  const positionOffset =
    Math.round((controlThumbWidth * position) / 100) - controlThumbWidth / 2;

  bubble.textContent = `${computedStepValue}`;
  bubble.style.left = `calc(${position}% - ${positionOffset}px)`;
  rangeLine.style.width = `calc(${position}% - ${positionOffset}px)`;
  range.setAttribute('value', computedStepValue);
};

const updateCalculatorState = (rangeValue) => {
  const computedStepValue = steps[rangeValue];
  let { count: checkedApps, totalPrice: pricePerApp } = getCheckedAppsData();
  let saveAmount = 0;

  const appsTotal = pricePerApp * computedStepValue;
  const bundleTotal = cakeBundlePrice * computedStepValue;

  if (pricePerApp > 0) {
    saveAmount = (pricePerApp - cakeBundlePrice) * computedStepValue * 12;
    saveAmount = Math.round(saveAmount * 100) / 100;
  }

  updatePriceElement(selectedSoftwarePrice, appsTotal);
  updatePriceElement(selectedBundlePrice, bundleTotal);
  updatePriceElement(saveAmountElement, saveAmount);
  saveAmountSmallElement.textContent = formatPriceUsStandard(saveAmount);

  repalaceAppCount.textContent = checkedApps;
  replaceAppCountSmall.textContent = checkedApps;
  numOfPeople.textContent = computedStepValue;

  totalUsers.forEach(element => {
    const userText = computedStepValue === 1 ? 'user' : 'users';
    element.textContent = `${computedStepValue} ${userText}`;
  });
};

const updateCompareBoxes = () => {
  compareSoftwareBoxes.forEach(compareElement => {
    compareElement.classList.remove('active');
  });

  softwareBoxItems.forEach(element => {
    if (element.classList.contains('active')) {
      const dataAttrName = element.dataset.id;
      compareSoftwareBoxes.forEach(compareElement => {
        if (compareElement.dataset.id === dataAttrName) {
          compareElement.classList.add('active');
        }
      });
    }
  });
};


softwareBoxItems.forEach(element => {
  element.addEventListener('click', function () {
    const activeItems = document.querySelectorAll('.software-box-item.active').length;

    if (this.classList.contains('active') && activeItems <= 2) {
      selectAppWarning.classList.add('!visible');
      return;
    }
    selectAppWarning.classList.remove('!visible');

    this.classList.toggle('active');

    updateCompareBoxes();
    updateCalculatorState(range.value);
  });
});

range.addEventListener('input', () => {
  setValue();
  updateCalculatorState(range.value);
});


document.addEventListener('DOMContentLoaded', () => {
  range.value = 11;
  setValue();

  updateCompareBoxes();
  updateCalculatorState(range.value);
});